import axios from 'axios';
import { environment } from '../../environments/environment';


export const apiClient = axios.create({
  baseURL: environment.apiEndPoint,
});
export {GraphService} from './graph.service';